import type { NavItemType } from 'types';
import type { WorkflowStatusId } from 'types/workflow/workflow-status';

/**
 * שש תצוגות מקבילות לתצוגות המערכת — לכל המשתמשים (מסנן משתמשים בראש הקבוצה).
 * כל URL כולל audience=team כדי להבדיל ממצב «שלי».
 */
export const TEAM_CHAT_VIEW_ITEMS: NavItemType[] = [
  {
    id: 'team-unassigned-chats',
    title: 'sidebar.nav.views.unassignedPendingAssign',
    workflowStatusId: 1 as WorkflowStatusId,
    type: 'item',
    url: '/chats/unassigned?audience=team',
    breadcrumbs: false,
    counterTone: 'urgent',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.unassignedPendingAssign',
  },
  {
    id: 'team-newly-assigned',
    title: 'sidebar.nav.views.firstReply',
    workflowStatusId: 2 as WorkflowStatusId,
    type: 'item',
    url: '/chats?wf=2&audience=team',
    breadcrumbs: false,
    counterTone: 'newWork',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.firstReply',
  },
  {
    id: 'team-awaiting-me',
    title: 'sidebar.nav.views.awaitingReply',
    workflowStatusId: 4 as WorkflowStatusId,
    type: 'item',
    url: '/chats?wf=4&audience=team',
    breadcrumbs: false,
    counterTone: 'urgent',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.awaitingReply',
  },
  {
    id: 'team-waiting-customer',
    title: 'sidebar.nav.views.awaitingCustomerShort',
    workflowStatusId: 3 as WorkflowStatusId,
    type: 'item',
    url: '/chats?wf=3&audience=team',
    breadcrumbs: false,
    counterTone: 'muted',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.awaitingCustomer',
  },
  {
    id: 'team-my-chats-snoozed',
    title: 'sidebar.nav.views.reminderByDate',
    workflowStatusId: 5 as WorkflowStatusId,
    type: 'item',
    url: '/chats?wf=5&audience=team',
    breadcrumbs: false,
    counterTone: 'muted',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.reminderByDate',
  },
  {
    id: 'team-chats-completed',
    title: 'sidebar.nav.views.completedArchive',
    workflowStatusId: 6 as WorkflowStatusId,
    type: 'item',
    url: '/chats/completed?audience=team',
    breadcrumbs: false,
    counterTone: 'muted',
    viewTooltipId: 'sidebar.nav.views.tooltip.team.completedArchive',
  },
];

export const TEAM_CHAT_VIEW_BY_ID: Record<string, NavItemType> = Object.fromEntries(
  TEAM_CHAT_VIEW_ITEMS.map((it) => [it.id!, it]),
);
